import React from 'react';

import { useStyledTheme } from 'hooks/useStyledTheme';

import SvgIcon from '../SvgIcon';

const IconFirstStep = (props: React.SVGAttributes<SVGSVGElement>) => {
  const theme = useStyledTheme();

  return (
    <SvgIcon viewBox="0 0 287 267" {...props}>
      <g transform="translate(0 1)">
        <path fill="#FFF" d="M37 30h250v170H37z" />
        <path fill="none" stroke="#C2D2DA" strokeWidth="2" d="M38 31h248v168H38z" />
        <rect fill="#C2D2DA" x="47" y="37" width="4" height="4" rx="2" />
        <rect fill="#C2D2DA" x="55" y="37" width="4" height="4" rx="2" />
        <rect fill="#C2D2DA" x="63" y="37" width="4" height="4" rx="2" />
        <ellipse fill="#E5EBED" cx="206.5" cy="263" rx="57.5" ry="3" />
        <ellipse fill="#E5EBED" cx="27.5" cy="243" rx="27.5" ry="3" />
        <path fill="#E5EBED" d="M39 46h246v152H39z" />
        <path
          stroke={theme.colors.fountainBlue}
          strokeLinecap="square"
          strokeWidth="2"
          d="M146 30a30 30 0 1 1-60 0 30 30 0 0 1 60 0z"
          fill="#FFF"
        />
        <path
          stroke={theme.colors.fountainBlue}
          strokeLinecap="square"
          strokeWidth="2"
          d="M116 7v5m16.3 1.7l-3.6 3.6M139 30h-5m-41 0h5m13.8-4.2L100 14m22 16a6 6 0 1 1-12 0 6 6 0 0 1 12 0z"
          fill="none"
        />
        <path fill="#FFF" d="M6 165h41v10H6z" />
        <path
          d="M7 175a5 5 0 0 1 0-10h40v4"
          stroke={theme.colors.fountainBlue}
          strokeWidth="2"
          fill="#FFF"
          strokeLinecap="square"
        />
        <path
          d="M58 191v-16H7a5 5 0 0 1-5-5v41a8 8 0 0 0 8 8h48v-16"
          stroke={theme.colors.fountainBlue}
          strokeWidth="2"
          fill="#FFF"
          strokeLinecap="square"
        />
        <path
          d="M62 203H48a6 6 0 1 1 0-12h14v12z"
          stroke={theme.colors.fountainBlue}
          strokeWidth="2"
          fill="#FFF"
          strokeLinecap="square"
        />
        <path d="M50 197a2 2 0 1 1-4 0 2 2 0 0 1 4 0z" fill={theme.colors.fountainBlue} />
        <path
          d="M70.5 80a11.5 11.5 0 1 0 0 23 11.5 11.5 0 0 0 0-23zm6.3 7.8l-8 8-.3.2-.3-.1-4-4a.5.5 0 0 1 0-.8c.2-.2.5-.2.7 0l3.6 3.7 7.7-7.7c.2-.2.5-.2.7 0 .2.2.2.5 0 .7z"
          fill="#C2D2DA"
        />
        <path fill="#C2D2DA" opacity=".3" d="M93 88h45v7H93zm0 33h45v7H93zm0 33h45v7H93z" />
        <path
          d="M70.5 113a11.5 11.5 0 1 0 0 23 11.5 11.5 0 0 0 0-23zm6.3 7.8l-8 8-.3.2-.3-.1-4-4a.5.5 0 0 1 0-.8c.2-.2.5-.2.7 0l3.6 3.7 7.7-7.7c.2-.2.5-.2.7 0 .2.2.2.5 0 .7zM70.5 146a11.5 11.5 0 1 0 0 23 11.5 11.5 0 0 0 0-23zm6.3 7.8l-8 8-.3.2-.3-.1-4-4a.5.5 0 0 1 0-.8h.7l3.6 3.7 7.7-7.7h.7c.2.3.2.6 0 .8z"
          fill="#C2D2DA"
        />
        <rect fill="#FAF4F7" x="159" y="60" width="116" height="160" rx="4" />
        <rect stroke="#D4C3C9" strokeWidth="2" x="160" y="61" width="114" height="158" rx="4" />
        <path fill="#DEE9EE" d="M159 60h116v160H159z" />
        <path
          fill="none"
          stroke={theme.colors.fountainBlue}
          strokeWidth="2"
          d="M160 61h114v158H160z"
        />
        <path fill="#FFF" d="M237.5 80l27.5 27.5V240H149V80h88.5z" />
        <path
          fill="none"
          stroke={theme.colors.accent}
          strokeWidth="2"
          d="M237 81h-87v158h114V108l-27-27z"
        />
        <path fill="none" stroke={theme.colors.accent} strokeWidth="2" d="M236 81v27.7h28" />
        <path
          fill={theme.colors.accent}
          d="M165 103h24v4h-24zm59 110h24v4h-24zm-59-83h84v2h-84zm15 54h68v2h-68zm0 6h34v2h-34zm-15-7h10v10h-10zm0-43h84v2h-84zm0 10h84v2h-84zm0 10h42v2h-42z"
        />
        <path fill="none" stroke="#FFF" d="M167 188l2 2 4-4" />
      </g>
    </SvgIcon>
  );
};

export default IconFirstStep;
